/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const SpinnerIcon = /*#__PURE__*/ createSvgIcon(
  'SpinnerIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.5 6V2h1v4h-1zm6.454-1.246l-2.74 2.74-.708-.708 2.74-2.74.707.708zm-9.168 2.74l-2.74-2.74.708-.708 2.74 2.74-.708.708zM6 10.5H2v-1h4v1zm12 0h-4v-1h4v1zM7.494 13.213l-2.74 2.74-.708-.707 2.74-2.74.708.707zm7.752 2.74l-2.74-2.74.707-.707 2.74 2.74-.707.707zM9.5 18v-4h1v4h-1z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default SpinnerIcon;
